"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _ServiceUrlUtility = _interopRequireDefault(require("../../util/ServiceUrlUtility"));

var _ServiceSettings = _interopRequireDefault(require("../../ServiceSettings"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SERVICE_PATH = '/retail/iows/{apiLocalePath}/customer/irw/{userId}/shoppingbags/';
/**
 * This class handles CRUD operations for IOWS shopping bag API.
 */

var ShoppingBagService = /*#__PURE__*/function (_AbstractService) {
  _inherits(ShoppingBagService, _AbstractService);

  var _super = _createSuper(ShoppingBagService);

  function ShoppingBagService() {
    var _this;

    _classCallCheck(this, ShoppingBagService);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "serviceVersion", '2.0');

    return _this;
  }

  _createClass(ShoppingBagService, [{
    key: "addToCart",

    /**
     * Returns cart count.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {string} config.bagType Bag type.
     * @param {string} config.bagName Bag name.
     * @returns {Promise} Promise object.
     */
    value: function addToCart(config) {
      var _this2 = this;

      return this._getBagInfo(config).then(function (bagInfo) {
        if (bagInfo !== null) {
          var updateConfig = Object.assign({}, config, {
            bagId: bagInfo.id
          });
          return _this2._updateBagItems(updateConfig).then(function (response) {
            if (response && response.ErrorList && response.ErrorList.length > 0) {
              return response;
            }

            return _this2._getCartCount(updateConfig).then(function (CartCount) {
              return {
                CartCount: CartCount,
                ErrorList: []
              };
            });
          });
        } else {
          return _this2._createBag(config);
        }
      });
    }
    /**
     * Returns cart count.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {string} config.bagType Bag type.
     * @param {string} config.bagName Bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getCartCount",
    value: function getCartCount(config) {
      var _this3 = this;

      return this._getBagInfo(config).then(function (bagInfo) {
        if (bagInfo !== null) {
          return _this3._getCartCount(Object.assign(config, {
            bagId: bagInfo.id
          }));
        } else {
          return 0;
        }
      });
    }
    /**
     * Returns bag information (name and id) if a bag exists.
     * Returns null if the bag doesn't exist.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {string} config.bagType Bag type.
     * @param {string} config.bagName Bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getBagInfo",
    value: function _getBagInfo(config) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this4._getUrl(config.apiLocalePath, config.userId) + config.bagType, {
          method: 'GET',
          headers: _this4._getHeaders(),
          credentials: 'include'
        }).then(_this4._handleJsonResponse.bind(_this4)).then(function (data) {
          resolve(_this4._parseBagInfo(data, config.bagName));
        }).catch(_this4._rejectWrapper.bind(_this4, reject));
      });
    }
    /**
     * Returns cart count for a shopping bag.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {number} config.bagId Bag id.
     * @param {string} config.bagType Bag type.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCartCount",
    value: function _getCartCount(config) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5._getBag(config).then(function (data) {
          resolve(_this5._calculateCartCountFromResponse(data));
        }).catch(_this5._rejectWrapper.bind(_this5, reject));
      });
    }
    /**
     * Returns a shopping bag.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {number} config.bagId Bag id.
     * @param {string} config.bagType Bag type.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getBag",
    value: function _getBag(config) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this6._getUrl(config.apiLocalePath, config.userId) + config.bagType + '/' + config.bagId, {
          method: 'GET',
          headers: _this6._getHeaders(),
          credentials: 'include'
        }).then(_this6._handleJsonResponse.bind(_this6)).then(function (data) {
          resolve(data);
        }).catch(_this6._rejectWrapper.bind(_this6, reject));
      });
    }
    /**
     * Creates a shopping bag.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {string} config.bagType Bag type.
     * @param {string} config.bagName Bag name.
     * @param {object[]} config.items Items to use.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_createBag",
    value: function _createBag(config) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        var jsonConfig = {
          userId: config.userId,
          items: config.items,
          bagType: config.bagType,
          bagName: config.bagName
        };
        fetch(_this7._getUrl(config.apiLocalePath, config.userId) + config.bagType, {
          method: 'POST',
          headers: _this7._getHeaders(),
          credentials: 'include',
          body: 'list=' + JSON.stringify(_this7._createShoppingBagModelJSON(jsonConfig))
        }).then(_this7._handleJsonResponse.bind(_this7)).then(function (data) {
          return resolve(_this7._parseResponse(data));
        }).catch(_this7._rejectWrapper.bind(_this7, reject));
      });
    }
    /**
     * Updates a shopping bag.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {string} config.bagType Bag type.
     * @param {number} config.bagId Bag id.
     * @param {string} config.bagName Bag name.
     * @param {object[]} config.items Items to use.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_updateBag",
    value: function _updateBag(config) {
      var _this8 = this;

      return new Promise(function (resolve, reject) {
        var jsonConfig = {
          userId: config.userId,
          items: config.items,
          bagType: config.bagType,
          bagName: config.bagName,
          bagId: config.bagId
        };
        fetch(_this8._getUrl(config.apiLocalePath, config.userId) + config.bagType + '/' + config.bagId, {
          method: 'PUT',
          headers: _this8._getHeaders(),
          body: 'list=' + JSON.stringify(_this8._createShoppingBagModelJSON(jsonConfig)),
          credentials: 'include'
        }).then(_this8._handleTextResponse.bind(_this8)).then(function (data) {
          resolve(_this8._parseResponse(data));
        }).catch(_this8._rejectWrapper.bind(_this8, reject));
      });
    }
    /**
     * Updates shopping bag items.
     *
     * @param {object} config Configuration object.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.userId User ID.
     * @param {string} config.bagType Bag type.
     * @param {number} config.bagId Bag id.
     * @param {object[]} config.items Items to use.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_updateBagItems",
    value: function _updateBagItems(config) {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this9._getUrl(config.apiLocalePath, config.userId) + config.bagType + '/' + config.bagId + '/items', {
          method: 'PUT',
          headers: _this9._getHeaders(),
          body: 'list=' + JSON.stringify(_this9._createShoppingBagAdjustmentItemListModelJSON(config.items)),
          credentials: 'include'
        }).then(_this9._handleTextResponse.bind(_this9)).then(function (data) {
          var response = _this9._parseResponse(data);

          resolve(response);
        }).catch(_this9._rejectWrapper.bind(_this9, reject));
      });
    }
    /**
     * Parses response.
     *
     * @param {object} response Response.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_parseResponse",
    value: function _parseResponse(response) {
      response = typeof response === 'string' && response.includes('{') ? JSON.parse(response) : response;
      var parsed = {
        ErrorList: [],
        CartCount: response && response.ShoppingBag ? this._calculateCartCountFromResponse(response) : null
      };

      if (_typeof(response) === 'object' && response !== null && response.ErrorList) {
        response.ErrorList.Error = Array.isArray(response.ErrorList.Error) ? response.ErrorList.Error : [response.ErrorList.Error];

        var _iterator = _createForOfIteratorHelper(response.ErrorList.Error),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var error = _step.value;
            var errorItem = {
              Code: error.ErrorCode && error.ErrorCode.$ ? error.ErrorCode && error.ErrorCode.$ : null,
              Message: error.ErrorMessage && error.ErrorMessage.$ ? error.ErrorMessage && error.ErrorMessage.$ : null,
              ItemNo: null
            };

            if (error.ErrorAttributeList && Array.isArray(error.ErrorAttributeList.ErrorAttribute)) {
              var _iterator2 = _createForOfIteratorHelper(error.ErrorAttributeList.ErrorAttribute),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var attribute = _step2.value;

                  if (attribute.Value && attribute.Value.$) {
                    errorItem.ItemNo = attribute.Value.$;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }

            parsed.ErrorList.push(errorItem);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return parsed;
    }
    /**
     * Calculates cart count from data.
     *
     * @param {object} data Data returned from the response.
     * @returns {number} Cart count or error object.
     */

  }, {
    key: "_calculateCartCountFromResponse",
    value: function _calculateCartCountFromResponse(data) {
      var cartCount = 0;

      if (data.ShoppingBag && data.ShoppingBag.BagType && (data.ShoppingBag.BagType.$ === 'ONLINESHOPPINGCART' || data.ShoppingBag.BagType.$ === 'ONLINESHOPPINGLIST') && data.ShoppingBag.ShoppingBagSectionList && data.ShoppingBag.ShoppingBagSectionList.ShoppingBagSection && data.ShoppingBag.ShoppingBagSectionList.ShoppingBagSection.ShoppingBagItemList) {
        var items = data.ShoppingBag.ShoppingBagSectionList.ShoppingBagSection.ShoppingBagItemList.ShoppingBagItem;
        var array = Array.isArray(items) ? items : [items];

        var _iterator3 = _createForOfIteratorHelper(array),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;

            if (item.ItemQty) {
              cartCount += item.ItemQty.$;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return cartCount;
    }
    /**
     * Parses bag data and returns bag info.
     *
     * @param {object} data Items to use.
     * @param {string} bagName Bag name.
     * @returns {object} Parsed data.
     */

  }, {
    key: "_parseBagInfo",
    value: function _parseBagInfo(data, bagName) {
      var bagInfo = null;

      if (data.ShoppingBag && data.ShoppingBag.BagId) {
        bagInfo = {
          id: data.ShoppingBag.BagId.$,
          name: data.ShoppingBag.BagName && data.ShoppingBag.BagName.$ ? data.ShoppingBag.BagName.$ : null,
          type: data.ShoppingBag.BagType && data.ShoppingBag.BagType.$ ? data.ShoppingBag.BagType.$.toLowerCase() : null
        };
      } else if (data.ShoppingBagRefList && data.ShoppingBagRefList.ShoppingBagRef) {
        if (Array.isArray(data.ShoppingBagRefList.ShoppingBagRef)) {
          var _iterator4 = _createForOfIteratorHelper(data.ShoppingBagRefList.ShoppingBagRef),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var ref = _step4.value;

              if (ref.BagId && (!ref.BagName || !ref.BagName.$ || !ref.BagType || !ref.BagType.$ || ref.BagName.$ === (_ServiceSettings.default.irwBagName || bagName))) {
                bagInfo = {
                  id: ref.BagId.$,
                  name: ref.BagName && ref.BagName.$ ? ref.BagName.$ : null,
                  type: ref.BagType && ref.BagType.$ ? ref.BagType.$.toLowerCase() : null
                };
                break;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        } else if (data.ShoppingBagRefList.ShoppingBagRef.BagId) {
          var _ref = data.ShoppingBagRefList.ShoppingBagRef;
          bagInfo = {
            id: _ref.BagId.$,
            name: _ref.BagName && _ref.BagName.$ ? _ref.BagName.$ : null,
            type: _ref.BagType && _ref.BagType.$ ? _ref.BagType.$.toLowerCase() : null
          };
        }
      }

      if (bagInfo && bagInfo.type && bagInfo.name && bagInfo.name !== (_ServiceSettings.default.irwBagName || bagName)) {
        return null;
      }

      return bagInfo;
    }
    /**
     * Returns a URL to be used by requests.
     *
     * @param {string} apiLocalePath API locale path. Example: "gb/en".
     * @param {string} userId User ID.
     * @returns {string} Generated URL.
     */

  }, {
    key: "_getUrl",
    value: function _getUrl(apiLocalePath, userId) {
      return _ServiceUrlUtility.default.getBaseUrl() + SERVICE_PATH.replace('{apiLocalePath}', apiLocalePath).replace('{userId}', userId);
    }
    /**
     * Returns headers to be used by requests.
     *
     * @param {string} [accept] Accepted type. Default is "application/vnd.ikea.iows+json".
     * @returns {object} Object as key value pairs of headers.
     */

  }, {
    key: "_getHeaders",
    value: function _getHeaders() {
      var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'application/vnd.ikea.iows+json';
      return {
        Accept: accept + '; version=' + this.serviceVersion,
        'Content-Type': 'application/x-www-form-urlencoded',
        Contract: _ServiceSettings.default.contract.toString(),
        Consumer: _ServiceSettings.default.consumer
      };
    }
    /**
     * Generates a shopping bag model to be used as JSON.
     *
     * @param {object} config Configuration.
     * @param {string} config.userId User ID.
     * @param {object[]} config.items Items to use.
     * @param {string} config.bagType Bag type.
     * @param {string} config.bagName Bag name.
     * @param {number} [config.bagId] Bag id.
     * @returns {object} Shopping bag model.
     */

  }, {
    key: "_createShoppingBagModelJSON",
    value: function _createShoppingBagModelJSON(config) {
      var json = {
        ShoppingBag: {
          BagType: {
            $: config.bagType
          },
          BagSource: {
            $: 'IRW'
          },
          BagName: {
            $: _ServiceSettings.default.irwBagName || config.bagName
          },
          CustomerSource: {
            $: 'IRW'
          },
          CustomerId: {
            $: config.userId
          },
          CreatedDateTime: {
            $: this._getCreatedTime()
          },
          ShoppingBagSectionList: [{
            ShoppingBagSection: {
              ShoppingBagItemList: {
                ShoppingBagItem: []
              }
            }
          }],
          '@xmlns': {
            $: 'ikea.com/cem/iows/ShoppingBagService/2.0/'
          }
        }
      };
      var list = json.ShoppingBag.ShoppingBagSectionList[0].ShoppingBagSection.ShoppingBagItemList.ShoppingBagItem;

      var _iterator5 = _createForOfIteratorHelper(config.items),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;

          if (typeof item.id !== 'string' || typeof item.type !== 'string' || typeof item.qty !== 'number') {
            throw new _ServiceException.default('Item was not in a valid format. Please use this format: { id: 123456, type: "ART", qty: 1 }', this.constructor.factoryName);
          }

          list.push({
            ItemType: {
              $: item.type.toUpperCase()
            },
            ItemNo: {
              $: item.id
            },
            ItemQty: {
              $: item.qty
            }
          });
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (config.bagId) {
        json.BagId = {
          $: config.bagId
        };
      }

      return json;
    }
    /**
     * Generates a shopping bag adjustment list model to be used as JSON.
     *
     * @param {object[]} items Items to use.
     * @returns {object} Shopping bag model.
     */

  }, {
    key: "_createShoppingBagAdjustmentItemListModelJSON",
    value: function _createShoppingBagAdjustmentItemListModelJSON(items) {
      var json = {
        ShoppingBagAdjustmentItemList: {
          ShoppingBagAdjustmentItem: [],
          '@xmlns': {
            $: 'ikea.com/cem/iows/ShoppingBagService/2.0/'
          }
        }
      };
      var list = json.ShoppingBagAdjustmentItemList.ShoppingBagAdjustmentItem;

      var _iterator6 = _createForOfIteratorHelper(items),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var item = _step6.value;

          if (typeof item.id !== 'string' || typeof item.type !== 'string' || typeof item.qty !== 'number') {
            throw new _ServiceException.default('Item was not in a valid format. Please use this format: { id: 123456, type: "ART", qty: 1 }', this.constructor.factoryName);
          }

          list.push({
            ItemType: {
              $: item.type.toUpperCase()
            },
            ItemNo: {
              $: item.id
            },
            ItemQty: {
              $: item.qty
            },
            SectionId: {
              $: 0
            }
          });
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return json;
    }
    /**
     * Returns a date ISO string of the current time.
     *
     * @returns {string} Date ISO string.
     */

  }, {
    key: "_getCreatedTime",
    value: function _getCreatedTime() {
      return new Date().toISOString();
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'shoppingbag';
    }
  }]);

  return ShoppingBagService;
}(_AbstractService2.default);

exports.default = ShoppingBagService;